import {
    ArrowDownward,
    ArrowUpward,
    CheckCircle,
    HighlightOff,
    HighlightOffOutlined,
    PauseCircle,
    Remove,
} from '@mui/icons-material'

export const destinationOptions = [
    { value: 0, label: 'Order' },
    { value: 1, label: 'Inventory' },
    { value: 2, label: 'Job Order' },
    { value: 3, label: 'Project' },
]

export const priorityOptionsForRequest = [
    { value: 1, label: 'Planned ' },
    { value: 0, label: 'Urgent' },
    { value: 2, label: 'Business Critical' },
]

export const buyerDefaults = [
    { buyerCode: "GUNEL KARIMOVA", buyerName: "GUNEL KARIMOVA" },
    { buyerCode: "NATAVAN ALIYEVA", buyerName: "NATAVAN ALIYEVA" },
    { buyerCode: "RUSTAM YAGUBOV", buyerName: "RUSTAM YAGUBOV" },
]

export const priorityOptions = [
    { value: 1, label: 'Low' },
    { value: 2, label: 'Medium ' },
    { value: 3, label: 'Higth' },
]

export const conditionOptions = [
    { value: 0, label: 'New' },
    { value: 1, label: 'Used' },
]

export const approvalStatus = [
    { value: 'Not Approved', label: 'Not Approved' },
    { value: 'On 1 Stage', label: 'On 1 Stage' },
    { value: 'On 2 Stage', label: 'On 2 Stage' },
    { value: 'On 3 Stage', label: 'On 3 Stage' },
    { value: 'On N Stage', label: 'On N Stage' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Hold', label: 'Hold' },
    { value: 'Partially Approved', label: 'Partially Approved' },
]

export const statusRequest = [
    { statusId: 1, statusName: 'Draft' },
    { statusId: 2, statusName: 'Requested' },
    {
        statusId: 3,
        statusName: 'Converted',
        icon: <CheckCircle sx={{ color: 'green', position: 'absolute', left: '78px', bottom: '6px' }} />,
    },
    {
        statusId: 4,
        statusName: 'Rejected',
        icon: <HighlightOff sx={{ color: 'red', position: 'absolute', left: '70px', bottom: '6px' }} />,
    },
    { statusId: 5, statusName: 'Partly Converted' },
]

const emergencyStyle = (background) => {
    return { background, color: 'white', borderRadius: '50%' }
}

export const emergencies = [
    { value: 1, label: 'Low', icon: <ArrowDownward sx={emergencyStyle('green')} /> },
    { value: 2, label: 'Medium', icon: <Remove sx={emergencyStyle('grey')} /> },
    { value: 3, label: 'High', icon: <ArrowUpward sx={emergencyStyle('red')} /> },
]

export const conditions = [
    { value: 0, label: 'Any' },
    { value: 1, label: 'Used' },
    { value: 2, label: 'New' },
]

export const MWPOptions = [
    { value: "YES", label: 'YES' },
    { value: "NO", label: 'NO' },
]

export const genderArray = [
    { id: 1, gender: 'Male' },
    { id: 2, gender: 'Female' },
]

export const themeArray = [
    { id: 0, theme: 'light' },
    { id: 1, theme: 'dark' },
]

export const userStatusArray = [
    { id: 0, name: 'Draft' },
    { id: 1, name: 'Active' },
    { id: 2, name: 'Inactive' },
]

export const userApprovalStatusArray = [
    { id: 0, name: 'Not Approved' },
    { id: 1, name: 'Approved' },
    { id: 2, name: 'Rejected' },
    { id: 3, name: 'Held' },
]

export const approvalStatusArray = [
    { approvalStatusId: 0, approvalStatusName: 'Not Approved' },
    { approvalStatusId: 1, approvalStatusName: 'İn Approve Stage' },
    { approvalStatusId: 2, approvalStatusName: 'Approved' },
    { approvalStatusId: 3, approvalStatusName: 'Held' },
    { approvalStatusId: 4, approvalStatusName: 'Rejected' },
]

export const statusArray = [
    { statusId: 1, statusName: 'Draft' },
    { statusId: 2, statusName: 'Active' },
    { statusId: 3, statusName: 'Inactive' },
    { statusId: 4, statusName: 'Deleted' },
]

export const statusList = [
    { statusId: 0, statusName: 'Draft' },
    { statusId: 1, statusName: 'Open' },
    { statusId: 2, statusName: 'Ready' },
    { statusId: 3, statusName: 'Bank' },
    { statusId: 4, statusName: 'Closed' },
    { statusId: 5, statusName: 'Canceled' },
]

export const vendorStatusArray = [
    { statusId: 0, statusName: 'Draft' },
    { statusId: 1, statusName: 'Submited' },
    { statusId: 2, statusName: 'Open' },
    { statusId: 3, statusName: 'Closed' },
]

export const vendorApprovalStatusArray = [
    { approvalStatusId: 0, approvalStatusName: 'Not Approved' },
    { approvalStatusId: 1, approvalStatusName: 'In Approve Stage' },
    { approvalStatusId: 2, approvalStatusName: 'Approved' },
    { approvalStatusId: 3, approvalStatusName: 'Rejected' },
    { approvalStatusId: 4, approvalStatusName: 'Held' },
]

export const orderApprovalStatus = [
    { approvalStatusId: 0, approvalStatusName: 'Not Approved' },
    { approvalStatusId: 1, approvalStatusName: 'Approved' },
    { approvalStatusId: 2, approvalStatusName: 'Rejected' },
    { approvalStatusId: 3, approvalStatusName: 'Held' },
    { approvalStatusId: 4, approvalStatusName: 'Partly Approved' },
]


export const paymentStatusOptions = [
    { statusId: 0, statusName: 'Not Paid' },
    { statusId: 1, statusName: 'Partly Paid' },
    { statusId: 2, statusName: 'Paid' },
]

export const bidComparsionApprovalStatuses = [
    { approvalStatusId: 0, approvalStatusName: 'Not Approved', },
    { approvalStatusId: 1, approvalStatusName: 'In Approval Stage', },
    { approvalStatusId: 2, approvalStatusName: 'Lost', },
    { approvalStatusId: 3, approvalStatusName: 'Rejected', },
    { approvalStatusId: 4, approvalStatusName: 'Won', },
    { approvalStatusId: 5, approvalStatusName: 'Held', },
]

export const bidComparsionStatuses = [
    { statusId: 0, statusName: 'Draft' },
    { statusId: 1, statusName: 'In BID' },
    { statusId: 2, statusName: 'Converted' },
    { statusId: 3, statusName: 'Partly Converted' },
    { statusId: 4, statusName: 'Ready co Convert' },
    { statusId: 5, statusName: 'Rejected' },
]

export const bidComparsionOrderStatuses = [
    { value: 0, label: 'Not Converted' },
    { value: 1, label: 'Converted' },
    { value: 2, label: 'Partly Converted' },
]

export const orderTypeData = [
    {
        orderTypeId: 2,
        orderType: 'Purchase Order',
    },
    {
        orderTypeId: 3,
        orderType: 'Service Order',
    },
    {
        orderTypeId: 5,
        orderType: 'Rent Order',
    },
    {
        orderTypeId: 6,
        orderType: 'Logistics Order',
    },
]

export const orderStatus = [
    { statusId: 0, statusName: 'Draft' },
    { statusId: 1, statusName: 'Open' },
    { statusId: 2, statusName: 'Closed' },
    { statusId: 3, statusName: 'Partly Closed' },
]

export const orderGrnStatus = [
    { grnStatusId: 0, grnStatusName: 'Not Available for Receiving' },
    { grnStatusId: 1, grnStatusName: 'Available for Receiving' },
    { grnStatusId: 2, grnStatusName: 'Part Received' },
    { grnStatusId: 3, grnStatusName: 'Fully Received' },
    { grnStatusId: 4, grnStatusName: 'N/A' },
]

export const orderInvoiceStatus = [
    { invoiceStatusId: 0, invoiceStatusName: 'Not Available for Invoicing' },
    { invoiceStatusId: 1, invoiceStatusName: 'Available for Invoicing' },
    { invoiceStatusId: 2, invoiceStatusName: 'Part Invoiced' },
    { invoiceStatusId: 3, invoiceStatusName: 'Fully Invoiced' },
    { invoiceStatusId: 4, invoiceStatusName: 'N/A' },
]

export const discountType = [
    { discountTypeId: 0, discountTypeName: 'No Discount' },
    { discountTypeId: 1, discountTypeName: 'Percent' },
    { discountTypeId: 2, discountTypeName: 'Amount' },
]

export const biddingTypes = [
    { value: 1, label: 'Automatic' },
    { value: 2, label: 'Manual' },
]


export const dataInvoiceFake = [
    {
        invoiceId: 1,
        totalAmount: '5',
        invoiceNo: '12',
        invoiceReceivedDate: '1111',
    },
    {
        invoiceId: 2,
        totalAmount: '5',
        invoiceNo: '113',
        invoiceReceivedDate: '1113',
    },
    {
        invoiceId: 3,
        totalAmount: '5',
        invoiceNo: '42',
        invoiceReceivedDate: '1212',
    },
]

export const DATE_FORMAT = 'YYYY-MM-DD'
export const FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const EUROPE_DATE_FORMAT = 'DD/MM/YYYY'
export const MAIN_EUROPE_DATE_FORMAT = 'DD.MM.YYYY'